import React from 'react'
import styled from '@emotion/styled'
import { Power } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import { Tooltip, Menu, IconButton as MuiIconButton } from '@mui/material'
import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded'
import { useLogout } from '../modules/user/userHooks'

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`

function UserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState(null)
  const { logoutUser } = useLogout()
  const history = useNavigate()

  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorMenu(null)
  }

  const handleSignOut = async () => {
    await logoutUser()
    history('/auth/sign-in')
  }

  const ProfileClick = async () => {
    history('/user/profile')
  }

  return (
    <>
      <Tooltip title="Profile">
        <IconButton
          aria-owns={anchorMenu ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={ProfileClick}
          color="inherit"
          size="large"
        >
          <AccountBoxRoundedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Logout">
        <IconButton
          aria-owns={anchorMenu ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={handleSignOut}
          color="inherit"
          size="large"
        >
          <Power />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        {/* <MenuItem onClick={ProfileClick}>Profile</MenuItem> */}
        {/* <MenuItem onClick={EditPasswordClick}>Edit Password</MenuItem> */}
      </Menu>
    </>
  )
}

export default UserDropdown
